import Almahome from "./alma.webp";
import Frescohome from "./fresco.webp";
import Granadahome from "./granada.webp";
import Materahome from "./matera.webp";
import Mentenggrandhome from "./menteng.webp";
import Narahome from "./nara.webp";
import Newmentenghome from "./newmenteng.webp";
import Pasadenahome from "./pasadena.webp";
import Pasadenavhome from "./pasadenav.webp";
import Zumahome from "./zuma.webp";
import Altadenahome from "./altadena.png";
import materaSignaturehome from "./materaSignature.png";
import materaLakesidehome from "./materaLake.png";
import anzahome from "./anza.png";

const Rumahimages = {
  Altadenahome,
  Almahome,
  Frescohome,
  Granadahome,
  Materahome,
  Mentenggrandhome,
  Narahome,
  Newmentenghome,
  Pasadenahome,
  Pasadenavhome,
  Zumahome,
  materaSignaturehome,
  materaLakesidehome,
  anzahome,
};

export default Rumahimages;
